module.exports = __webpack_public_path__ + "static/media/Contrat de licence.7919c06b.pdf";